module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "visible": "",
      "size": "lg",
      "hide-footer": true,
      "title": "Locatie gescand"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h1', [_vm._v("Locatie gescand: " + _vm._s(_vm.location) + " "), _c('h4', {
    staticStyle: {
      "display": "block",
      "margin-top": "px"
    }
  }, [_vm._v("Aan welke locatie wil je het toevoegen")])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "margin-right": "25px"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.update('location')
      }
    }
  }, [_vm._v("Standaard locatie")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "margin-right": "25px"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.update('overstock_location')
      }
    }
  }, [_vm._v("Locatie overvoorraad")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Annuleren")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b6c810e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/products/UpdateLocationModal.vue
// module id = 731
// module chunks = 1